<script lang="jsx">
import { Platform } from "@osgfe/jiemo-base";
import XxMainLayout from "../../components/MainLayout.vue";
import { ACCOUNT_TYPE } from "@/constants";
import { sendAllPageViewEventMetric } from "@/constants/log";

export default {
  name: "XxPlatform",
  components: {
    XxMainLayout,
  },
  provide() {
    return {
      $xxPlatform: this,
    };
  },
  computed: {
    accountInfo() {
      return this.$store.getters.accountInfo;
    },
    supplierInfo() {
      return this.$store.getters.supplierInfo;
    },
    accountTypeByPath() {
      return this.$store.getters.accountTypeByPath;
    },
    merchantState() {
      return this.$store.getters.merchantState;
    },

    isRTL() {
      return this.$i18nClient.getCurrentLocale() === "ar";
    },
  },
  created() {
    this.initAccountInfo();
  },
  mounted() {
    this.updateRTLStyle(this.isRTL);
  },
  methods: {
    updateRTLStyle(isRTL) {
      const htmlNode = document.documentElement;
      if (isRTL) {
        return htmlNode && htmlNode.setAttribute("dir", "rtl");
      }
      return htmlNode && htmlNode.setAttribute("dir", "");
    },
    async initAccountInfo() {
      try {
        this.$store.commit("setAccountTypeByPath");
        await this.$store.dispatch("getAccountInfo");
        if (this.accountTypeByPath === ACCOUNT_TYPE.SUPPLIER) {

          await this.$store.dispatch("getMerchantStateApi");
          console.log('account-info has been called');
          await this.$store.dispatch("getSupplierInfoByBizAccountIdApi");
        }
      } catch (error) {
        console.error(`System request exception: ${error}`);
      } finally {
        sendAllPageViewEventMetric();
        document.cookie = `msid=${this.accountInfo.login}; `;
      }
    },
  },
  render(h) {
    return new Platform({
      render() {
        return (<xx-main-layout />);
      },
    }).mount(h);
  },
};
</script>


<style scoped>
.vss-min-layout,
.vss-container {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.mtd-header {
  z-index: 2;
}
.mtd-aside {
  z-index: 2;
}
.mtd-main {
  background-color: #f0f0f0;
}
.yxfe-main-container {
  background-color: #f0f0f0;
  display: block;
  -webkit-box-flex: 1;
  flex: 1;
  padding: 0;
}
</style>
